import MlRecommendationTag from 'components/Product/MlRecommendationTag/MlRecommendationTag';

export { BESTSELLER_SIGNAL_ID } from 'components/Product/MlRecommendationTag/MlRecommendationTag';

export default MlRecommendationTag;
